
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import BtnCheck from "@/components/scope/btn-check.vue";
import dayjs from "dayjs";
import { priceRulesEl, mobileRulesEl, partsQuantityRules } from "@common/src/utils/verify";
import t from "@common/src/i18n/t";
import { addCurrencyUnit } from "@common/src/utils/tools";
import MyCheckbox from "@common/src/components/scope/my-checkbox/index.vue";
const staff = namespace("staff");
const parts = namespace("parts");
const user = namespace("user");
const app = namespace("app");
const common_app = namespace("common_app");
const base = namespace("base");
const inventory = namespace("inventory");
const supplier = namespace("supplier");
const purchase = namespace("purchase");
const common_base = namespace("common_base");
Component.registerHooks(["beforeRouteLeave"]);
@Component({
  components: { BtnCheck, MyCheckbox }
})
export default class ServiceEdit extends Vue {
  @app.Mutation setPBPX;
  @supplier.Action getSupplierList;
  @supplier.Action getSupplierDetail;
  @supplier.Action createSupplier;
  @staff.Action getStaffList;
  @parts.Action getPartsList;
  @inventory.Action queryPartsQtyByWarehouseTree;
  @purchase.Action getPurchaseDetail;
  @user.State userData;
  @base.Action getDictionaryList;
  @purchase.Action savePurchase;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @common_base.State showPlatformParts;
  @common_app.State country;
  dayjs = dayjs;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  formBeEditCount = 0;
  showQuitConfirm = false;
  get breadData() {
    return [
      { name: t("purchase.purchase-manage"), path: "/purchase/index" },
      {
        name: this.isAdd ? t("purchase.create-purchase-text") : t("purchase.edit-purchase-text")
      }
    ];
  }
  get additionalData() {
    return [
      {
        additionalFees: this.orderFormData.additionalFees,
        additionalFeesRemark: this.orderFormData.additionalFeesRemark
      }
    ];
  }
  get isAdd() {
    return this.$route.name === "purchaseAdd";
  }
  get selectedParts() {
    return this.orderFormData.detailList.map(i => i.partsCode);
  }
  @Watch("orderFormData", { deep: true })
  WatchOrderData() {
    this.formBeEditCount += 1;
  }
  checkPrice(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      priceRulesEl(value, callback);
    }
  }
  newSupplierDataRules: any = {
    supplierName: [{ required: true, message: t("setting.enter-supplier-name"), trigger: "blur" }],
    contactMobile: { validator: this.validateMobile, trigger: "blur" }
  };
  handleShowCreateSupplier() {
    this.showCreateSupplier = true;
  }
  validateMobile(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      mobileRulesEl(value, callback);
    }
  }
  supplierSearchValue: string = "";
  get isEditUnitPrice() {
    return true;
  }
  showAdditional: boolean = false;
  advisorList: any[] = [{}];
  emptyToLine = emptyToLine;
  orderFormData: any = {
    supplierCode: "", // 供应商code
    purchaseDate: "", // 采购日期
    purchaseUser: "", // 采购人
    remark: "", // 备注
    additionalFees: "", // 附加费用
    additionalFeesRemark: "", // 附加费用备注
    detailList: [], // 零配件列表
    purchaseAmount: 0 // 合计采购成本
  };
  orderFormDataRules: any = {
    supplierCode: { required: true, message: t("finance.please-select-supplier"), trigger: "change" }
  };
  definitionPartsData: any = {
    partsInfo: {},
    qty: "",
    totalInventory: 0,
    costPrice: "",
    costAmount: "",
    partsCode: "",
    warehouseCode: "",
    shelfCode: "",
    remark: "",
    list: []
  };

  serviceItemList: any[] = [];
  showCreateSupplier: boolean = false;
  newSupplierData: any = {
    supplierName: "",
    contactName: "",
    contactMobile: ""
  };
  partsList: any[] = [];
  get orderId() {
    return this.$route.params.id;
  }
  handleConfirmCreateSupplier() {
    (this.$refs.addSupplierForm as any).validate(valid => {
      if (valid) {
        this.createSupplier(this.newSupplierData).then(data => {
          this.$message.success(t("base.success") as any);
          this.supplierList.push({
            supplierName: this.newSupplierData.supplierName,
            supplierCode: data.data.supplierCode
          });
          this.$nextTick(() => {
            this.orderFormData.supplierCode = data.data.supplierCode;
          });
          this.showCreateSupplier = false;
          this.handleSupplierChange(data.data.supplierCode);
        });
      }
    });
  }
  addAdditionCost() {
    // 控制附加费用表格显示
    this.showAdditional = true;
  }
  deleteAdditional() {
    this.showAdditional = false;
    this.orderFormData.additionalFees = "";
    this.orderFormData.additionalFeesRemark = "";
  }
  created() {
    this.setPBPX(100);
    this.init();
    this.handleAddParts(); // 默认添加第一行
  }
  inWarehouseTypeList: any = [];
  supplierList: any = [];
  searchSupplierList(val = "") {
    this.supplierSearchValue = val;
    this.getSupplierList({
      pageNum: 1,
      pageSize: 10,
      searchKey: val
    }).then(data => {
      let list = this.$safeValue(data, "data.list", []);
      this.supplierList = list.filter(v => v.status === 1);
    });
  }
  async init() {
    this.searchSupplierList();
    this.getDictionaryList("inbound_type").then(data => {
      this.inWarehouseTypeList = data.filter(item => item.dataValue !== "3");
    });
    this.getPartsLists();
    await this.getStaffList({
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.advisorList = data.data.list;
    });
    if (!this.isAdd) {
      this.getPurchaseDetail({
        purchaseNo: this.orderId
      }).then(data => {
        data.data.purchaseDate && (data.data.purchaseDate = dayjs(data.data.purchaseDate).format("YYYYMMDD"));
        data.data.additionalFees && (this.showAdditional = true);
        this.orderFormData = data.data;
        this.seletedSupplierData.contactName = this.orderFormData.supplierContactName;
        this.seletedSupplierData.contactMobile = this.orderFormData.supplierContactMobile;
        data.data.detailList.forEach(item => {
          if (
            !this.partsList.some(partsItem => {
              return partsItem.partsCode === item.partsCode;
            })
          ) {
            this.partsList.push(item);
          }
          item.purchasePrice = item.costPrice;
        });
        data.data.detailList.forEach((item, index) => {
          this.handleChooseParts(item.partsCode, index, item, "init");
        });
      });
    } else {
      this.orderFormData.purchaseDate = dayjs().format("YYYYMMDD");
      this.orderFormData.purchaseUser = this.userData.userCode;
    }
  }
  getPartsLists(name = "") {
    this.getPartsList({
      pageNum: 1,
      pageSize: 20,
      searchKey: name,
      notOpadmin: this.showPlatformParts ? "0" : "1"
    }).then(data => {
      this.partsList = (data.data?.list || []).map(item => {
        item.partsNameDesc = item.partsCustomizeCode
          ? `${item.partsNameDesc}(${item.partsCustomizeCode})`
          : item.partsNameDesc;
        return item;
      });
    });
  }
  computedAmount(index) {
    let costAmount = (this.orderFormData.detailList[index].qty || 0) * this.orderFormData.detailList[index].costPrice;
    this.orderFormData.detailList[index].costAmount = costAmount.i18nToFixed();
    this.computedTotalAmount();
  }
  computedTotalAmount() {
    let partsTotal = this.orderFormData.detailList.reduce((preV, curV) => preV + Number(curV.costAmount), 0);
    let allAmount = partsTotal + Number(this.orderFormData.additionalFees);
    if (Object.is(NaN, allAmount)) {
      this.$message.error(t("setting.enter-quantity-or-amount"));
    }
    this.orderFormData.purchaseAmount = allAmount.i18nToFixed();
  }
  searchParts(val) {
    this.getPartsLists(val);
  }

  handleChooseParts(val, index, row, type = "manual") {
    if (!this.shelfPartsMap[val]) {
      this.shelfPartsMap[val] = [];
    }
    this.queryPartsQtyByWarehouseTree({
      partsCode: val
    }).then(data => {
      const warehouseList = data?.data?.warehouseList || [];
      const defaultWarehouse = warehouseList.find(item => item.defaultWarehouse === 1);
      const partsInfo = warehouseList[0];
      let partsData = Object.assign({}, row, {
        partsCode: val,
        partsInfo: partsInfo,
        list: warehouseList,
        totalInventory: data.data.inventoryQty,
        costPrice: row.purchasePrice || partsInfo.purchasePrice || "0.00"
      });
      if (type === "manual") {
        if (defaultWarehouse) {
          partsData.warehouseCode = defaultWarehouse.warehouseCode;
          this.handleWarehouseChange(partsData, type);
        }
      } else {
        this.handleWarehouseChange(partsData, type);
      }
      this.orderFormData.detailList.splice(index, 1, partsData);
      this.computedAmount(index);
    });
  }

  checkAddData(): boolean {
    if (this.orderFormData.detailList.length < 1) {
      this.$message.error(`${t("base.add-at-least-one-item")}${t("parts.text")}`);
      return false;
    }
    for (let index = 0; index < this.orderFormData.detailList.length; index++) {
      const element = this.orderFormData.detailList[index];
      if (!element.partsCode) {
        this.$message.error(`${t("base.please-select")}${t("parts.text")}`);
        return false;
      }
      if (!element.qty) {
        this.$message.error(`${t("base.please-input")}${t("purchase.purchase-quantity")}`);
        return false;
      }
      const checkPartsQty = partsQuantityRules(element.qty);
      if (!checkPartsQty.success) {
        this.$message.error(checkPartsQty.msg);
        return false;
      }
      if (this.orderFormData.inboundType === "1" && !element.costPrice) {
        this.$message.error(`${t("base.please-input")}${t("warehouse.cost-unit-price")}`);
        return false;
      }
      if (!element.warehouseCode || !element.shelfCode) {
        this.$message.error(t("v210.please-select-the-warehousing-warehouse-location"));
        return false;
      }
    }
    return true;
  }
  operationName: string = "";
  showInwarehouse: boolean = false;
  partsHasZero: boolean = false;
  handleComplete() {
    this.operationName = "save";
    if (
      this.orderFormData.detailList.some(parts => {
        return Number(parts.costPrice) === 0;
      })
    ) {
      this.partsHasZero = true;
      this.showInwarehouse = true;
    } else {
      this.emitSavePurchase();
    }
  }
  emitSavePurchase() {
    this.orderFormData.detailList.forEach(item => {
      let part = this.$safeValue(item, "list", []).find(v => v.warehouseCode === item.warehouseCode);
      if (part) {
        item.warehouseName = part.warehouseName;
        item.specification = part.specification;
      }
    });
    this.orderFormData.supplierContactName = this.seletedSupplierData.contactName;
    this.orderFormData.supplierContactMobile = this.seletedSupplierData.contactMobile;
    this.orderFormData.supplierName = this.seletedSupplierData.supplierName;
    this.orderFormData.purchaseUserName = this.advisorList.find(
      v => v.userCode === this.orderFormData.purchaseUser
    ).staffName;
    (this.$refs["purchaseInfo"] as any).validate(valid => {
      if (valid && this.checkAddData()) {
        this.btnStartLoading();
        this.savePurchase(this.orderFormData)
          .then(data => {
            this.formBeEditCount = 2;
            this.$message.success(t("base.save-success") as string);
            this.$router.push(`/purchase/purchase-view/${data.data.purchaseNo}`);
          })
          .finally(() => {
            this.btnStopLoading();
          });
      } else {
        console.log("error submit!!");
      }
    });
  }
  seletedSupplierData: any = {};
  handleSupplierChange(val) {
    if (!val) {
      this.seletedSupplierData = {};
    } else {
      this.getSupplierDetail({
        supplierCode: val
      }).then(data => {
        this.seletedSupplierData = data.data;
      });
    }
  }
  handleAddParts() {
    this.orderFormData.detailList.push(Object.assign({}, this.definitionPartsData));
  }
  deleteItem(key, index) {
    this.orderFormData[key].splice(index, 1);
    this.updateShelfEnableMap();
  }
  handleOpPartsShowChange() {
    this.getPartsLists();
  }
  handleWarehouseChange(row, type = "manual") {
    let seletedWarehouse = row.list.find(item => row.warehouseCode === item.warehouseCode);
    row.shelfList = seletedWarehouse?.shelfList || [];
    const defaultShelf = row.shelfList.find(item => item.defaultShelf === 1);
    if (type === "manual") {
      if (defaultShelf && !this.checkShelfEnable(row, defaultShelf)) {
        row.shelfCode = defaultShelf.shelfCode;
      } else {
        row.shelfCode = "";
      }
    }
    this.updateShelfEnableMap();
  }
  handleShelfSelectFocus(row) {
    if (!row.warehouseCode) {
      this.$message.error(t("v210.please-select-the-spare-parts-and-warehouse-first"));
    }
  }
  shelfPartsMap: any = {};
  handleShelfChange() {
    this.updateShelfEnableMap();
  }
  // 当仓库和库位发生变化更新零配件和库位的映射，即同一个零配件和相同库位只能存在一行
  updateShelfEnableMap() {
    let tempMap = {};
    this.orderFormData.detailList.forEach(item => {
      let curShelfCode = item.shelfCode;
      if (!tempMap[item.partsCode]) {
        tempMap[item.partsCode] = [];
      }
      curShelfCode && tempMap[item.partsCode].push(curShelfCode);
    });
    this.shelfPartsMap = tempMap;
  }
  checkShelfEnable(partsRow, shelfRow) {
    return (
      this.shelfPartsMap[partsRow.partsCode].includes(shelfRow.shelfCode) && partsRow.shelfCode !== shelfRow.shelfCode
    );
  }

  beforeRouteLeave(to, form, next) {
    if (this.formBeEditCount > 2) {
      this.showQuitConfirm = true;
      next(false);
    } else {
      next();
    }
  }

  handleExitConfirm() {
    this.showQuitConfirm = false;
    this.formBeEditCount = 2;
    this.returnHandle();
  }
  returnHandle() {
    this.$router.replace({ name: "purchaseList" });
  }
}
